import { PERMISSIONS } from "@/services/permission"
import { FEATURE_SETS } from "@/services/featureSet"
import { requireSuppliers } from "@/router/routes/supplier"

export default [
  {
    path: "/material/list",
    name: "MaterialOverview",
    component: () => import("@/views/material/MaterialOverview"),
    meta: {
      title: "nav.material.overview",
      requiresAuth: true,
      // Either right opens the page: it lists the catalogue's records and its packets, and shows
      // whichever of the two the reader may read (`services/catalogPackets.js`).
      requiresPermissions: [PERMISSIONS.VIEW_MATERIAL_GENERAL, PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
  {
    path: "/material/create",
    name: "MaterialCreate",
    component: () => import("@/views/material/MaterialCreate"),
    meta: {
      title: "material.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_MATERIAL_GENERAL],
    },
  },
  // Two materials side by side, by their suppliers' prices (docs/suppliers.md, "Artikel vergleichen"): part of the
  // add-on SUPPLIER_INSIGHTS, on top of SUPPLIERS (`requireSuppliers`). Before the record route only for reading's
  // sake: a static segment outranks `:materialId` anyway.
  {
    path: "/material/comparison",
    name: "MaterialComparison",
    component: () => import("@/views/material/MaterialComparison.vue"),
    beforeEnter: requireSuppliers,
    meta: {
      title: "supplierInsights.item_comparison.title.MATERIAL",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_MATERIAL_GENERAL, PERMISSIONS.VIEW_MATERIAL_PURCHASEPRICE],
      requiresFeatureSet: FEATURE_SETS.SUPPLIER_INSIGHTS,
    },
  },
  {
    path: "/material/:materialId",
    name: "MaterialDetail",
    props: true,
    component: () => import("@/views/material/MaterialDetail"),
    meta: {
      title: "nav.material.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_MATERIAL_GENERAL],
    },
  },
]
